import { createSelector } from 'reselect';
import { GeneralUser } from '@mews-commander/data-access';
import { getProp } from '@mews/fp';
import { getCurrentEnterpriseSubscription } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { getCurrentScopeAssignedLearningPath } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { isFunctionalConsentGiven } from '../../trackingConsent/selectors';

export const getUserBeamerConfiguration = createSelector(
    getProp<GeneralUser>()('user'),
    getCurrentEnterpriseSubscription,
    getCurrentScopeAssignedLearningPath,
    isFunctionalConsentGiven,
    ({ firstName, lastName, email, id, languageCode }, { tier }, learningPath, isConsentGiven) => {
        const baseConfig = {
            language: languageCode,
            user_id: id,
            role: learningPath,
            tier,
        };

        if (!isConsentGiven) {
            return baseConfig;
        }

        return {
            ...baseConfig,
            user_firstname: firstName,
            user_lastname: lastName,
            user_email: email,
        };
    }
);

export const IFRAME_SELECTORS = {
    beamerUtilities: '#beamerUtilities',
    pciProxy: '#iframe-cardNumber',
} as const;
